"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CourtSystemAttribute = void 0;
/*
 * Not every court system setting needs to be added here.
 * This only includes settings that are used as targets.
 */
var CourtSystemAttribute;
(function (CourtSystemAttribute) {
    CourtSystemAttribute["RecordingLicense"] = "RecordingLicense";
    CourtSystemAttribute["RestApiKey"] = "RestApiKey";
})(CourtSystemAttribute || (exports.CourtSystemAttribute = CourtSystemAttribute = {}));
